import { LUX_INPUT_TYPE, LuxTextInput, LuxInputSwitch, useWindowResize } from '@lux/wardrobe-lib'
import './saving-filters.scss'
import FilterCategories from '../FilterCategories/FilterCategories'
import { useIntl } from 'react-intl'

const SavingFilters = ({ filterItems, nameFilter, setNameFilter, isDefault, setIsDefault }) => {
    const intl = useIntl()

    const isMobile = useWindowResize()

    return (
        <div className="smart-modals-saving-filters">
            {!isMobile && (
                <h2 className="section-title">
                    {intl.formatMessage({
                        id: 'modals.filters.label.save_filters',
                        defaultMessage: 'Save Filters',
                    })}
                </h2>
            )}
            <div className="search-input-container">
                <LuxTextInput
                    label={intl.formatMessage({
                        id: 'modals.filters.label.filter_name',
                        defaultMessage: 'Filter Name',
                    })}
                    type={LUX_INPUT_TYPE.text}
                    value={nameFilter}
                    placeholder={intl.formatMessage({
                        id: 'modals.filters.label.type_here',
                        defaultMessage: 'Type here',
                    })}
                    onChangeCallback={setNameFilter}
                    icon="pencil"
                    iconPosition="right"
                    mandatory
                />
                <div className="disclaimer">
                    <i className="cu cu-info" />
                    <p>
                        {intl.formatMessage({
                            id: 'modals.filters.label.once_saved',
                            defaultMessage:
                                'Once saved, this filter will appear in your Saved Filters.',
                        })}
                    </p>
                </div>
            </div>
            {!isMobile && (
                <p className="subtitle">
                    {intl.formatMessage({
                        id: 'modals.filters.label.default_filter',
                        defaultMessage: 'Default Filter',
                    })}
                </p>
            )}
            <LuxInputSwitch
                label={intl.formatMessage({
                    id: 'modals.filters.label.default_filter',
                    defaultMessage: 'Default Filter',
                })}
                value={isDefault}
                onChangeCallback={(value) => setIsDefault(value)}
            />
            {isMobile && <FilterCategories filterItems={filterItems} showSavingFilter />}
        </div>
    )
}

export default SavingFilters
